/**
 * Паспорт страницы в одном месте.
 *
 * 🔴 Заведено 03.09.2026. До него `setHeadTag` был скопирован в тринадцать
 * шаблонов, и каждый сам решал, какие метки поставить. Разъехались они
 * предсказуемо: семь шаблонов ставили `og:*` и не ставили `twitter:*`, поэтому
 * 27 страниц уезжали в соцсети и к ИИ-краулерам под заголовком ГЛАВНОЙ. Ни одна
 * проверка этого не видела — метка на месте, значение чужое.
 *
 * Правило: перечень социальных меток объявлен ЗДЕСЬ и только здесь. Шаблон
 * сообщает, что за страница, а не какие теги ей положены.
 */
const SITE = 'https://www.morganlegalny.com';

export function setHeadTag(selector: string, attr: 'content' | 'href', value: string) {
  const el = document.querySelector(selector) as HTMLMetaElement | HTMLLinkElement | null;
  if (el) (el as unknown as Record<string, string>)[attr] = value;
}

export interface PageMeta {
  title: string;
  description: string;
  /** Путь со слэшами по краям либо готовый абсолютный адрес. */
  url: string;
  type?: 'website' | 'article' | 'profile';
  /** Абсолютный адрес картинки. Без него остаётся общесайтовая. */
  image?: string;
}

/**
 * Ставит заголовок, описание, канонический адрес и ВСЕ социальные метки.
 * `twitter:*` следуют за `og:*` по построению, а не по дисциплине автора.
 */
export function applyPageMeta({ title, description, url, type = 'website', image }: PageMeta) {
  if (typeof document === 'undefined') return;
  const canonical = url.startsWith('http') ? url : `${SITE}${url}`;
  document.title = title;
  setHeadTag('meta[name="description"]', 'content', description);
  setHeadTag('link[rel="canonical"]', 'href', canonical);
  setHeadTag('meta[property="og:title"]', 'content', title);
  setHeadTag('meta[property="og:description"]', 'content', description);
  setHeadTag('meta[property="og:url"]', 'content', canonical);
  setHeadTag('meta[property="og:type"]', 'content', type);
  setHeadTag('meta[name="twitter:title"]', 'content', title);
  setHeadTag('meta[name="twitter:description"]', 'content', description);
  if (image) {
    setHeadTag('meta[property="og:image"]', 'content', image);
    setHeadTag('meta[name="twitter:image"]', 'content', image);
  }
}
